import type {
  AlertRuleDetailsDTO,
  AlertRuleUpdateDTO
} from '@/pages/AlertRules/AlertRules.types';

import { EMPTY_ALERT_RULE_TEMPLATE } from './AlertRuleEditDialog.constants';

export const formatDefaultAlertRuleValues = (
  selectedAlertRule: AlertRuleDetailsDTO | null,
  selectedOrgId: number
) => {
  const defaultValues: AlertRuleUpdateDTO = {
    template_id: null,
    instructions: '',
    organization_instructions: null,
    ai_enabled: false,
    ai_escalation: false
  };

  Object.entries(EMPTY_ALERT_RULE_TEMPLATE).forEach(([field, value]) => {
    const typedField = field as keyof AlertRuleDetailsDTO;

    if (field === 'organization_instructions') {
      // Special handling for organization_instructions to get the instruction for the selected organization
      const orgSpecificInstructions =
        selectedAlertRule?.organization_instructions?.find(
          (orgInst) => orgInst.organization_id === selectedOrgId
        )?.instructions || '';
      (defaultValues as any)[typedField] = orgSpecificInstructions;
      return;
    }

    (defaultValues as any)[typedField] =
      selectedAlertRule?.[typedField] || value;
  });

  return defaultValues;
};

export default formatDefaultAlertRuleValues;
